module.exports = __webpack_public_path__ + "static/img/蒙版组 14.14e7a92.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/declaration/images/蒙版组 14.png
// module id = iayy
// module chunks = 0